<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="0.2" class="background-circular" src="/assets/img/background-circular.svg" alt="Background Circular" />
<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.14" class="background-circular" src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />


<app-navbar></app-navbar>

<div class="checkout" fxLayoutAlign="center center" *ngIf="step != 3 && step != 4 && step != 5">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%" fxLayoutGap="30px" fxLayoutAlign="start start">
        <div fxFlex="65%" fxFlex.md="50%">
            <app-step-one *ngIf="step == 1" [@stepsAnimation] (clickContinue)="clickStepOneContinue()"></app-step-one>
            <app-step-two *ngIf="step == 2" [@stepsAnimation] (clickContinue)="clickStepFiveContinue()" (clickBack)="clickBackOne()"></app-step-two>
        </div>
        <div fxFlex="35%" fxFlex.md="50%">
            <app-resume></app-resume>

            <button mat-flat-button class="button-help-center" (click)="onOpenHelp()">Centro de ayuda</button>
        </div>
    </div>
</div>

<div class="successful-message" *ngIf="step == 3">
    <app-step-three [@stepsAnimation]></app-step-three>
</div>

<div class="successful-message" *ngIf="step == 4">
    <app-step-four [@stepsAnimation]></app-step-four>
</div>

<div class="successful-message" *ngIf="step == 5">
    <app-step-five [@stepsAnimation]></app-step-five>
</div>

<!--<button mat-button (click)="clickSection(1)">Paso 1</button>
<button mat-button (click)="clickSection(2)">Paso 2</button>
<button mat-button (click)="clickSection(3)">Paso 3</button>-->


<app-footer></app-footer>